import axios from "axios";

class ContactUsApi
 {

  contactInquiry(formValues){
    const apiUrl = "/api/v1/inquiries";
    const csrfToken = document.head.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

    return axios.post(
      apiUrl, 
      {inquiry: formValues},
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
      }
    )
    .then(response => {
      const ok = response.status == 200;
      return Promise.resolve(ok);
    });
  }


  getStates(): Promise<any[]> {
    const apiUrl = "/api/v1/states";

    return axios.get(apiUrl)
    .then(response => {
      const states = response.data.map(res => ({value: res, label: res}));
      return Promise.resolve(states);
    });
  }

}

export default ContactUsApi
;